export function validateForm(setErrors, form) {
  console.table(form);
  //Clean up and set default values
  let county = form.county === " - " ? "" : form.county.trim();
  const description = form.description.trim();
  //const jobLength = form.jobLength > 0 ? "" : form.jobLength;
  const municipality = form.municipality === " - " ? "" : form.municipality;

  //Validate
  const errors = {
    description: description ? "" : "Du måste lägga till en beskrivning!",
    county: county ? "" : "Du måste välja ett län!",
    municipality: municipality ? "" : "Du måste välja en kommun!",
    //jobLength: jobLength === "" ? "" : "Vänligen ange jobblängd i dagar",
  };

  setErrors(errors);

  return Object.values(errors).every((x) => x == "");
}
